import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

import { SourcedocumentDataSchemaFor } from "./_gmw-event-schema-collection";

export const gmwRemovalSchema: SourcedocumentDataSchemaFor<"GMW_Removal"> = {
  type: "object",
  title: "Gebeurtenis gegevens",
  required: ["eventDate"],
  properties: pickGmwLibraryFields(["eventDate"]),
};
